import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { CurrencyDetectCollection } from './currency-detect.types';

export function currencyDetectBackend(): Backend<CurrencyDetectCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: () => ({
      endpoint: 'currency/detectCurrency.php',
      isGaf: true,
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
